import React, { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Agents = () => {
    const [agents, setAgents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAgents = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/agents`);
                const data = await response.json();
                if (Array.isArray(data)) {
                    setAgents(data);
                }
            } catch (error) {
                console.error("Error fetching agents:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchAgents();
    }, []);

    return (
        <div className="flex w-full flex-col gap-2 p-2">
            <div className="font-bold my-1 text-[18px] text-center">Agents</div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full overflow-y-auto">
                {loading ? (
                    // Skeleton Loader
                    Array(6).fill(0).map((_, index) => (
                        <div key={index} className="flex flex-col w-full p-2 gap-1 min-h-[60px] h-fit bg-slate-100 animate-pulse rounded-[12px]">
                            <div className="flex w-full items-center gap-4 flex-shrink-0">
                                <div className="h-[50px] w-[50px] bg-gray-300 rounded-[12px]"></div>
                                <div className="flex flex-col w-full">
                                    <div className="h-[14px] bg-gray-300 rounded w-[70%]"></div>
                                    <div className="h-[12px] bg-gray-300 rounded w-[50%] mt-1"></div>
                                    <div className="h-[12px] bg-gray-300 rounded w-[40%] mt-1"></div>
                                    <div className="h-[12px] bg-gray-300 rounded w-[60%] mt-1"></div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    // Actual Agents Data
                    agents.length > 0 ? (
                        agents.map((agent) => (
                            <div key={agent.id} className="flex flex-col w-full p-2 gap-1 min-h-[60px] h-fit bg-slate-100 hover:bg-slate-200 rounded-[12px]">
                                <div className="flex w-full items-center gap-4 flex-shrink-0">
                                    <img 
                                        src={agent.image_url} 
                                        alt={agent.name} 
                                        className="h-[50px] w-[50px] flex object-cover shrink-0 rounded-[12px]" 
                                    />
                                    <div className="flex flex-col w-full leading-[1.1]">
                                        <div className="text-[14px] font-bold line-clamp-1">{agent.name}</div>
                                        <div className="flex text-[12px]">{agent.type}</div>
                                        <div className="text-[12px] text-gray-400 w-fit">{agent.country}</div>
                                        <a href={`tel:${agent.phone_number}`} className="text-rose-600 text-[12px] hover:underline">
                                            {agent.phone_number}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center w-full text-gray-500">No agents available.</p>
                    )
                )}
            </div>
        </div>
    );
};

export default Agents;
